import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiCheckCircle, FiMaximize, FiLayout, FiTruck, FiWifi, FiX, FiPlay, FiPause, FiVolume2, FiVolumeX, FiExternalLink } = FiIcons;

const unitData = {
  "/310": {
    title: 'Nature Green',
    unitNumber: '310',
    subtitle: '5 Min to Convention Center • Pool View • Full Kitchen • Sleeps 6 • I‑Drive',
    seoTitle: '310 (5 Min to Convention Center • Pool • Full Kitchen • Sleeps 6 • I‑Drive)',
    tagline: '3rd Floor',
    video: "https://res.cloudinary.com/dwumujtpu/video/upload/q_auto/v1777158443/1-7601_Canada_Ave_310_uzqdfg.mp4",
    description: 'Welcome to your comfortable 1BR suite in the heart of International Drive — just 5 minutes from the Orange County Convention Center and 5–7 minutes from Universal Orlando. Whether you’re here for business, a convention, or a family getaway, this space offers everything you need for a relaxing and convenient stay.',
    features: ['3rd Floor', 'Pool-facing view', 'Comfortably Accommodates Up To 6 Guests', 'Full Kitchen', 'Samsung Smart TV with streaming channels', 'Free use of Business Center', 'Gym'],
    bookingLinks: [
      { name: 'Orlando Best Place', url: 'https://www.orlandobestplace.com/property/14023/?&lang=en_US' },
      { name: 'VRBO', url: 'https://www.vrbo.com/5094404' },
      { name: 'AirBnB', url: 'https://www.airbnb.com/rooms/1574078863232694072' }
    ],
    gallery: [
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158385/17-7601_Canada_Ave_310_bclnpb.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158376/16-7601_Canada_Ave_310_vagmad.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158401/19-7601_Canada_Ave_310_q916vn.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158408/20-7601_Canada_Ave_310_w6dvkt.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158353/13-7601_Canada_Ave_310_vyyduc.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158329/10-7601_Canada_Ave_310_vgshe8.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158290/5-7601_Canada_Ave_310_uurzfn.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158321/9-7601_Canada_Ave_310_xzokqh.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158313/8-7601_Canada_Ave_310_zqshze.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158282/4-7601_Canada_Ave_310_edtxmp.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158274/3-7601_Canada_Ave_310_oget5r.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777158369/15-7601_Canada_Ave_310_ladkj3.jpg"
    ]
  },
  "/414": {
    title: 'Royal Blue',
    unitNumber: '414',
    subtitle: 'Modern 1BR • 5 Min to OCCC • Pool View • Kitchen • Near Universal',
    seoTitle: '414 (Modern 1BR • 5 Min to Orange County Convention Center • Pool • Kitchen • Near Universal)',
    tagline: '4th Floor',
    video: "https://res.cloudinary.com/dwumujtpu/video/upload/q_auto/v1777169468/4f961f75-f8f6-4ae5-9d33-65900c00ba9d_epge8o.mov",
    description: 'Enjoy a stylish and comfortable stay in this updated 1BR suite located 5 minutes from the Orange County Convention Center and close to Universal Orlando. With a full kitchen, fast WiFi, and resort amenities, this is the perfect home base for both business and leisure.',
    features: ['4th Floor', 'Pool-facing view', 'High-Speed WiFi', 'Full Kitchen', 'Samsung Smart TV with streaming channels', 'Free use of Business Center', 'Gym'],
    bookingLinks: [
      { name: 'Orlando Best Place', url: 'https://www.orlandobestplace.com/property/15056/florida/orlando/apartment-near-epic-universal?&lang=en_US' },
      { name: 'VRBO', url: 'https://www.vrbo.com/5094545' },
      { name: 'AirBnB', url: 'https://www.airbnb.com/rooms/1592233481884656762?source_impression_id=p3_1781628270_P34HiU09deQp_L0R' }
    ],
    gallery: [
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156731/9-7601_Canada_Ave_414_z5fmwp.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156738/10-7601_Canada_Ave_414_lszxna.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156745/11-7601_Canada_Ave_414_ayedit.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156709/6-7601_Canada_Ave_414_c3tlb0.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156702/5-7601_Canada_Ave_414_wcllij.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156681/2-7601_Canada_Ave_414_lgdvrh.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156674/1-7601_Canada_Ave_414_xaklbz.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156723/8-7601_Canada_Ave_414_k22h31.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156717/7-7601_Canada_Ave_414_wlcwdh.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156752/12-7601_Canada_Ave_414_quplns.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156759/13-7601_Canada_Ave_414_otv8u1.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156816/21-7601_Canada_Ave_414_wrtenl.jpg"
    ]
  },
  "/612": {
    title: 'Cozy Grey',
    unitNumber: '612',
    subtitle: 'I‑Drive • 5 Min to OCCC • Pool View • Kitchen • Sleeps 6 • Near Universal',
    seoTitle: '612 (I‑Drive • 5 Min to OCCC • Pool • Kitchen • Sleeps 6 • Near Universal)',
    tagline: '6th Floor',
    video: "https://res.cloudinary.com/dwumujtpu/video/upload/q_auto/v1777156638/23-7601_Canada_Ave_612_fqxsrw.mp4",
    description: 'Relax in this bright and comfortable 1BR suite located 1.3 miles from the Orange County Convention Center and 5 minutes from Universal Orlando. With a full kitchen, fast WiFi, and resort amenities, this unit is perfect for families, convention attendees, and longer stays.',
    features: ['6th Floor', 'Pool-facing view', 'Comfortably Accommodates Up To 6 Guests', 'Full Kitchen', 'Samsung Smart TV with streaming channels', 'Free use of Business Center', 'Gym'],
    bookingLinks: [
      { name: 'Orlando Best Place', url: 'https://www.orlandobestplace.com/property/14026/?&lang=en_US' },
      { name: 'VRBO', url: 'https://www.vrbo.com/5094333' },
      { name: 'AirBnB', url: 'https://www.airbnb.com/rooms/1574078860557519648' }
    ],
    gallery: [
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156541/9-7601_Canada_Ave_612_li81ux.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156535/8-7601_Canada_Ave_612_kywrwm.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156503/3-7601_Canada_Ave_612_trkfjx.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156548/10-7601_Canada_Ave_612_uqnypn.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156574/14-7601_Canada_Ave_612_zf44rs.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156581/15-7601_Canada_Ave_612_yt4bgg.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156561/12-7601_Canada_Ave_612_izxfht.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156626/22-7601_Canada_Ave_612_mld2qj.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156587/16-7601_Canada_Ave_612_tjyxqr.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156567/13-7601_Canada_Ave_612_a2vk63.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156528/7-7601_Canada_Ave_612_b0ljjo.jpg",
      "https://res.cloudinary.com/dwumujtpu/image/upload/q_auto,f_auto,dpr_auto/v1777156613/20-7601_Canada_Ave_612_vxdbok.jpg"
    ]
  }
};

const UnitDetails = () => {
  const { pathname } = useLocation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);
  
  const unit = unitData[pathname] || unitData["/310"];

  useEffect(() => {
    const defaultTitle = document.title;
    const pageTitle = unit.seoTitle;
    document.title = pageTitle;

    const updateMetaTag = (selector, attribute, value) => {
      let el = document.querySelector(selector);
      let defaultVal = "";
      if (!el) {
        el = document.createElement('meta');
        if (selector.includes('property=')) {
          el.setAttribute('property', selector.match(/property="([^"]+)"/)[1]);
        } else if (selector.includes('name=')) {
          el.setAttribute('name', selector.match(/name="([^"]+)"/)[1]);
        }
        document.head.appendChild(el);
      } else {
        defaultVal = el.getAttribute(attribute);
      }
      el.setAttribute(attribute, value);
      return { el, defaultVal, attribute };
    };

    const metaChanges = [
      updateMetaTag('meta[name="description"]', 'content', unit.description),
      updateMetaTag('meta[property="og:title"]', 'content', pageTitle),
      updateMetaTag('meta[property="og:description"]', 'content', unit.description),
      updateMetaTag('meta[property="og:url"]', 'content', `https://7601canada.com${pathname}`),
      updateMetaTag('meta[property="og:image"]', 'content', unit.gallery[0]),
      updateMetaTag('meta[property="twitter:title"]', 'content', pageTitle),
      updateMetaTag('meta[property="twitter:description"]', 'content', unit.description),
      updateMetaTag('meta[property="twitter:image"]', 'content', unit.gallery[0])
    ];

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    const defaultCanonical = canonicalLink ? canonicalLink.getAttribute("href") : "";
    if (canonicalLink) {
      canonicalLink.setAttribute("href", `https://7601canada.com${pathname}`);
    }

    const schemaData = {
      "@context": "https://schema.org",
      "@type": "HotelRoom",
      "name": `${unit.title} Suite - Unit ${unit.unitNumber}`,
      "description": unit.description,
      "bed": {
        "@type": "BedDetails",
        "numberOfBeds": 2
      },
      "occupancy": {
        "@type": "QuantitativeValue",
        "value": 6
      },
      "image": unit.gallery[0],
      "url": `https://7601canada.com${pathname}`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "7601 Canada Ave",
        "addressLocality": "Orlando",
        "addressRegion": "FL",
        "postalCode": "32819",
        "addressCountry": "US"
      }
    };

    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.id = 'unit-schema';
    schemaScript.textContent = JSON.stringify(schemaData);
    document.head.appendChild(schemaScript);

    return () => {
      document.title = defaultTitle;
      
      metaChanges.forEach(({ el, defaultVal, attribute }) => {
        if (defaultVal) {
          el.setAttribute(attribute, defaultVal);
        }
      });

      if (canonicalLink && defaultCanonical) {
        canonicalLink.setAttribute("href", defaultCanonical);
      }
      
      const existingSchema = document.getElementById('unit-schema');
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, [unit, pathname]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setSelectedImage(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 group text-black/40 hover:text-black transition-colors mb-12 uppercase text-[10px] font-black tracking-widest outline-none focus:ring-2 focus:ring-black rounded px-2">
          <SafeIcon icon={FiArrowLeft} className="w-4 h-4 group-hover:-translate-x-1 transition-transform" /> Back to Home
        </Link>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 mb-32">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-orange text-white text-[10px] font-black uppercase tracking-widest">
                {unit.tagline}
              </span>
              
            </div>
            <h1 className="text-6xl md:text-8xl font-serif font-black text-black uppercase tracking-tighter leading-[0.9] mb-4">
              {unit.title}
            </h1>
            <p className="text-sm font-black uppercase tracking-widest text-accent-orange mb-8">
              {unit.subtitle}
            </p>
            <p className="text-xl text-black/60 leading-relaxed mb-12">
              {unit.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
              {unit.features.map((feature, i) => (
                <div key={i} className="flex items-center gap-3">
                  <SafeIcon icon={FiCheckCircle} className="text-accent-orange w-5 h-5 flex-shrink-0" />
                  <span className="text-xs font-black uppercase tracking-widest text-black">{feature}</span>
                </div>
              ))}
            </div>

            {/* Premium Booking Links Section */}
            <div className="mb-12 bg-black/5 p-8 rounded-[40px] border border-black/5">
              <h2 className="text-[10px] font-black uppercase tracking-[0.3em] text-accent-orange mb-8">Direct Booking Available</h2>
              <div className="flex flex-col gap-4">
                {unit.bookingLinks.map((link, idx) => (
                  <a
                    key={idx}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-between p-6 rounded-3xl bg-white border-2 border-transparent hover:border-black transition-all group shadow-sm hover:shadow-xl"
                  >
                    <span className="font-serif font-black uppercase tracking-tight text-lg text-black">{link.name}</span>
                    <div className="flex items-center gap-3 text-[10px] font-black uppercase tracking-widest text-black/40 group-hover:text-black transition-colors">
                      Book Now <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
                    </div>
                  </a>
                ))}
              </div>
            </div>

            <div className="flex gap-12 py-8 border-t border-black/5 overflow-x-auto pb-4">
              {[
                { icon: FiMaximize, label: 'Spacious' },
                { icon: FiLayout, label: 'Full Kitchen' },
                { icon: FiTruck, label: 'Free Parking' },
                { icon: FiWifi, label: 'Fast Wi-Fi' }
              ].map((item, i) => (
                <div key={i} className="text-center flex-shrink-0">
                  <SafeIcon icon={item.icon} className="w-6 h-6 mx-auto mb-2 text-black/20" />
                  <div className="text-[10px] font-black uppercase tracking-widest whitespace-nowrap">{item.label}</div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="relative aspect-square bg-black rounded-[40px] overflow-hidden group shadow-2xl"
          >
            {unit.video ? (
              <div className="relative w-full h-full">
                <video 
                  ref={videoRef}
                  src={unit.video} 
                  className="w-full h-full object-cover opacity-90"
                  autoPlay 
                  muted={isMuted}
                  loop 
                  playsInline
                />
                
                {/* Video Controls Overlay */}
                <div className="absolute inset-x-0 bottom-0 p-8 flex items-center justify-between bg-gradient-to-t from-black/60 to-transparent">
                  <div className="flex items-center gap-4">
                    <button 
                      onClick={togglePlay}
                      className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-full border border-white/30 hover:bg-white/40 transition-all text-white"
                      aria-label={isPlaying ? "Pause video" : "Play video"}
                    >
                      <SafeIcon icon={isPlaying ? FiPause : FiPlay} className="w-5 h-5 fill-current" />
                    </button>
                    <button 
                      onClick={toggleMute}
                      className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-full border border-white/30 hover:bg-white/40 transition-all text-white"
                      aria-label={isMuted ? "Unmute video" : "Mute video"}
                    >
                      <SafeIcon icon={isMuted ? FiVolumeX : FiVolume2} className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <img 
                src={unit.gallery[0]} 
                className="w-full h-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105 cursor-pointer" 
                alt={`${unit.title} suite interior at 7601 Canada Avenue`}
                onClick={() => setSelectedImage(unit.gallery[0])}
              />
            )}
          </motion.div>
        </div>

        <div className="mb-24">
          <h2 className="text-3xl font-serif font-black text-black uppercase tracking-tighter mb-12">Unit Gallery</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {unit.gallery.map((img, idx) => (
              <motion.div
                key={idx}
                whileHover={{ scale: 1.02 }}
                onClick={() => setSelectedImage(img)}
                className="aspect-square bg-black/5 rounded-3xl overflow-hidden group cursor-pointer"
                role="button"
                aria-label={`View gallery image ${idx + 1}`}
              >
                <img 
                  src={img} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                  alt={`${unit.title} suite interior photo ${idx + 1} at 7601 Canada Avenue`}
                  loading="lazy"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-6 md:p-12"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              className="absolute top-8 right-8 text-white/50 hover:text-white transition-colors z-10 p-2"
              onClick={() => setSelectedImage(null)}
            >
              <SafeIcon icon={FiX} className="w-8 h-8" />
            </button>
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="relative max-w-5xl w-full h-full flex items-center justify-center px-4"
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={selectedImage} 
                alt="Enlarged suite interior detail at 7601 Canada Avenue" 
                className="max-w-full max-h-[85vh] object-contain rounded-2xl shadow-2xl"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UnitDetails;